import React, { FunctionComponent } from 'react';
import { AuthenticatedTemplate } from "@azure/msal-react";
import { NavigationBar } from "./NavigationBar";
import { MenuNavigation } from '../components/MenuNavigation';
import { Footer } from './Footer';

interface IPageLayoutProps extends React.PropsWithChildren {
    onUserLoad: () => void;
    userLoaded: boolean;
  }

export const PageLayout: FunctionComponent<IPageLayoutProps> = (props) => {

    return (
        <>
            <div className="page-wrp d-flex flex-column">
                <NavigationBar onUserLoad={() => props.onUserLoad()}/>
                <div className="d-flex flex-row flex-fill">
                    <div id="main-nav-wrp">
                        {props.userLoaded &&
                            <MenuNavigation userLoaded={props.userLoaded}/>
                        }
                    </div>
                    <div className="content-wrp flex-fill">
                        <main id="main">
                            {props.children}
                        </main>
                    </div>
                </div>
                <AuthenticatedTemplate>
                    <Footer/>
                </AuthenticatedTemplate>
            </div>
        </>
    );
};